import './christmas-stage.scss';

class ChristmasStage {
    constructor ($element) {
        this.$stage = $element;
        this.$siteHeader = document.querySelector('[data-site-header]');
    }

    init () {
        console.log('christmas-stage');
        this.transparentHeader();
    }

    transparentHeader () {
        this.$siteHeader.classList.add('site-header--is-transparent');
    }
}

export { ChristmasStage };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $stages = $context.querySelectorAll('[data-christmas="root"]');

        for (let i = 0; i < $stages.length; i++) {
            const $stage = new ChristmasStage($stages[i]);
            $stage.init();
        }
    }
});
